import React from 'react';

import {
  Modal,
  Button,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

type Props = {
  isOpen: boolean,
  onRequestClose: { (): void },
};

const PaymentSuccessfulModal = ({
  isOpen,
  onRequestClose,
}: Props) => (
  <Modal
    title="Payment successful!"
    isOpen={isOpen}
    contentStyle={{
      marginTop: 'auto',
    }}
    onRequestClose={onRequestClose}
  >
    <Flex
      column
      width="100%"
      align="center"
      spacing={15}
    >
      <Text size="16px" align="center">
        Your subscription will automatically renew and your card will be
        charged unless updated or cancelled. Payments that have already
        been charged cannot be refunded. You can update your
        payment information by clicking your
        {' '}
        <b>Profile Image</b>
        {' '}
        and selecting
        {' '}
        <b>Payments</b>
        {' '}
        from the menu.
      </Text>
      <Flex spacing={10}>
        <Button
          ghost
          appearance="primary"
          spacing="large"
          onClick={onRequestClose}
        >
          Ok
        </Button>
      </Flex>
    </Flex>
  </Modal>
);

export default PaymentSuccessfulModal;
